import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/faq";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/faq")(
  enRouteOptions(routeOptions, {
    svPath: "/faq",
    title: 'Kunskapsprov FAQ – Booking, Cost, Pass Marks, Retakes',
    description: 'Answers about the Swedish kunskapsprov: how to book, what it costs, pass marks, retakes and how to prepare. For the test itself, start with the practice test.',

    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
